import React from "react";
import { Button, notification, Popconfirm, Row, Tag } from "antd";
import { Space, Title } from "./TaskDetailsHeader.styled";
import { useMode } from "../../organisms";
import { useQueryClient } from "react-query";
import { useMutation } from "@apollo/client/react";
import { DELETE_TASK, UPDATE_TASK, GET_TASKS } from "../../../graphql/tasks";
import { queryStringToObject } from "../../organisms/filters/Filter.utils";
import { useNavigate } from "react-router-dom";

export const TaskDetailsHeader: React.FC<{
  title: string;
  labels: any;
  status: any;
  delete_permission: any;
}> = ({ title, labels, status, delete_permission }) => {
  const queryClient = useQueryClient();
  const paramas = queryStringToObject(location.search);
  const navigate = useNavigate();

  const { mode, setMode } = useMode();

  const [updateTaskMutate, { loading: updateLoading }] = useMutation(UPDATE_TASK, {
    refetchQueries: ["Tasks"],
    onCompleted: () => {
      queryClient.invalidateQueries("/tasks");
      queryClient.invalidateQueries(["/task-details", paramas?.id]);
      notification.success({
        message: "Zapisano zmiany",
        style: {
          background: "#52c41a30",
        },
      });
      setMode("read");
    },
    onError: () => {
      notification.error({
        message: "Błąd zapisu danych",
        style: {
          background: "#ff4d4f30",
        },
      });
    },
  });

  const [deleteTaskMutate, { loading: deleteLoading }] = useMutation(DELETE_TASK, {
    refetchQueries: ["Tasks"],
    onCompleted: () => {
      queryClient.invalidateQueries("/tasks");
      notification.success({
        message: "Usunięto pomyślnie",
        style: {
          background: "#52c41a30",
        },
      });
      navigate({
        pathname: location.pathname,
        search: "",
      });
      setMode("read");
    },
    onError: () => {
      notification.error({
        message: "Błąd usuwania",
        style: {
          background: "#ff4d4f30",
        },
      });
    },
  });

  return (
    <Row justify="space-between" id="task-details-header">
      <Space size={"small"} direction="vertical">
        <Title level={4} copyable>
          {title}
        </Title>
        <Space size={"small"} direction="horizontal">
          {labels?.map((e: any) => {
            return (
              <Tag color={e?.color} key={e?.text}>
                {e?.text}
              </Tag>
            );
          })}
        </Space>
      </Space>
      <Space size={"small"} direction="horizontal">
        {(status === "NEW" || status === "ASSIGNED") && (
          <Button
            onClick={() =>
              updateTaskMutate({
                variables: {
                  id: Number(paramas?.id),
                  input: { status: "IN_PROGRESS" },
                },
              })
            }
            type="primary"
            loading={updateLoading}
          >
            Rozpocznij
          </Button>
        )}

        {status === "IN_PROGRESS" && (
          <Button
            onClick={() =>
              updateTaskMutate({
                variables: {
                  id: Number(paramas?.id),
                  input: { status: "DONE" },
                },
              })
            }
            type="primary"
            loading={updateLoading}
          >
            Zakończ
          </Button>
        )}

        {delete_permission && (
          <Popconfirm
            title="Usuń pozycje"
            description="Czy na pewno chcesz usunąć wybraną pozycję?"
            onConfirm={() =>
              deleteTaskMutate({ variables: { id: Number(paramas?.id) } })
            }
            okText="Tak"
            cancelText="Nie"
          >
            <Button danger disabled={deleteLoading}>
              Usuń
            </Button>
          </Popconfirm>
        )}

        <Button
          disabled={updateLoading}
          onClick={() => setMode(mode === "read" ? "edit" : "read")}
        >
          Edytuj
        </Button>
      </Space>
    </Row>
  );
};
